import React from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * Link clicks keep the previous page's scroll position unless reset here.
 * Back and forward are left alone so the browser can restore the position,
 * and URLs with a hash are left to jump to their anchor.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  React.useLayoutEffect(() => {
    if (navigationType === 'POP' || hash) return;
    window.scrollTo(0, 0);
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps

  return null;
}
